import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import ServicesHero from './components/ServicesHero';
import ProductGallerySection from './components/ProductGallerySection';
import DosageFormsSection from './components/DosageFormsSection';
import ServiceImageTextSection from './components/ServiceImageTextSection';
import ServiceCompareSection from './components/ServiceCompareSection';
import QualitySection from './components/QualitySection';
import ServiceProcessSection from './components/ServiceProcessSection';
import ServiceFaqSection from './components/ServiceFaqSection';
import ServiceCtaSection from './components/ServiceCtaSection';

export default function ServicesPage() {
  useSEO({
    title: '代工服務｜保健食品 OEM ODM 多元劑型代工｜康永生技',
    description: '康永生技提供保健食品 OEM/ODM 代工服務：17+ 熱銷配方、天然原料、6大劑型（膠囊/錠劑/粉劑/果凍條/茶包/液劑）、包裝設計，國際規範認證品質。',
    keywords: '保健食品代工服務,劑型代工,熱銷配方,天然原料,包裝設計,膠囊代工,錠劑代工',
    lang: 'zh-TW',
    canonicalPath: '/services',
  });

  return (
    <Layout>
      <SEOJsonLd
        type="WebPage"
        pageTitle="代工服務｜保健食品 OEM ODM 多元劑型代工｜康永生技"
        pageDescription="康永生技提供保健食品 OEM/ODM 代工服務：17+ 熱銷配方、天然原料、6大劑型、包裝設計。"
        pageUrl="https://kangyong.com/services"
      />
      <ServicesHero />
      <ProductGallerySection />
      <DosageFormsSection />
      <ServiceImageTextSection />
      <ServiceCompareSection />
      <QualitySection />
      <ServiceProcessSection />
      <ServiceFaqSection />
      <ServiceCtaSection />
    </Layout>
  );
}
